import { Token } from "@api/apiClient";
import { makeAutoObservable } from "mobx";

// TODO: we can remove this completely
export class ViewerToken {
  public token: Token | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    const viewerToken = localStorage.getItem("viewerToken");
    if (viewerToken) {
      try {
        this.token = JSON.parse(viewerToken);
      } catch (e) {
        console.error("Failed to parse viewer token from local storage", e);
      }
    }
  }

  public setToken(token: Token | null) {
    this.token = token;
    if (token === null) {
      localStorage.removeItem("viewerToken");
    } else {
      localStorage.setItem("viewerToken", JSON.stringify(token));
    }
  }
}
